<template>
  <ExpenseForm mode="edit" />
</template>

<script>
import ExpenseForm from "@/components/expense/ExpenseForm.vue";

export default {
  name: "editexpense",
  components: { ExpenseForm },
};
</script>
